import { useMemo } from 'react';
import { useIntl } from 'react-intl';
import { useSelector } from 'react-redux';
import { useTheme } from '@rossum/ui/material';
import { currentDatapointHasBbox } from '../datapoints/selector';
import { annotationProductTourSteps } from './useProductTour';

export const useDataCaptureTour = () => {
  const intl = useIntl();
  const datapointHasBbox = useSelector(currentDatapointHasBbox);
  const theme = useTheme();

  const steps = useMemo(
    () => annotationProductTourSteps(intl, datapointHasBbox, theme),
    [datapointHasBbox, intl, theme]
  );

  return { steps };
};
